import Vue from 'vue';
import axios from 'axios';
import { encodeUrlFromRouter, encodeUrlToRouter } from '@/routerUrlEncoding';
import syncReadingsSavedOffline from './syncReadings';

export default {
  name: 'books',
  components: {
    backButton: require('@/components/backButton/backButton.vue').default,
    CircleSpinner: require('@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue').default,
  },
  data: function () {
    return {
      onLine: navigator.onLine,
      bg: '',
      bgName: '',
      booksWalks: [],
      key: 0
    }
  },
  computed: {
  },
  watch: {
    onLine: function (value) {
      if (value) {
        syncReadingsSavedOffline(this.$store.state.readingsLocalDB);
      }
    },
  },
  beforeUnmount() {
  },
  created() {
    if (this.$store.state.userProfile.portalCaptureMeterReadings != true)
      this.$router.push('/employeeHome');

    this.onLine = navigator.onLine;

    this.bg = encodeUrlFromRouter(this.$route.params.bg);
    this.getBillingGroupName();
    this.getBooksWalksOffline();
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
    this.$store.commit('setCaptureMeterReadingsSearch', { offlineSearchType: '', offlineSearchText: '' });
  },
  beforeDestroy() {
    window.removeEventListener('online', this.updateOnlineStatus)
    window.removeEventListener('offline', this.updateOnlineStatus)
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;

      this.onLine = type === 'online';

      this.$store.commit('setCsAppsOfflineMode', { status: !this.onLine });
    },
    getBooksWalks() {
      axios.post('/CaptureMeterReading/GetBooksWalks', { Value: this.bg })
        .then(response => {
          if (response.status == 200 && response.data.items && response.data.items.length > 0) {
            response.data.items.map(item => { item.name = '[' + item.bookId + '] Walk: ' + item.walkId, item.enableOffline = false });

            this.booksWalks = response.data.items;
            this.saveDataIntoLocalDb();
          }
        })
        .catch(err => {
          this.$oldAlertMsg(err, 1);
        })
    },
    saveDataIntoLocalDb() {
      this.$store.state.readingsLocalDB.get(`bg_${this.bg}_booksWalks`)
        .then(doc => {
          this.$store.state.readingsLocalDB.put({
            _id: doc._id,
            _rev: doc._rev,
            bg: this.bg,
            booksWalks: this.booksWalks,
            datetime: new Date()
          });
        })
        .catch(err => {
          if (err.status == 404) {
            this.$store.state.readingsLocalDB.put({
              _id: `bg_${this.bg}_booksWalks`,
              bg: this.bg,
              booksWalks: this.booksWalks,
              datetime: new Date()
            });
          }
        })
    },
    selectBooksWalk(item) {
      //console.log(item);

      if (!this.onLine && !item.enableOffline)
        return;

      const bookId = encodeUrlToRouter(item.bookId);

      var route = `/captureMeterReadings2/${item.billingGroupId}/${bookId}/${item.walkId}`;
      this.$router.push(route);
    },
    getClass(id) {
      return 'md-primary';
    },
    getBooksWalksOffline() {
      this.$store.state.readingsLocalDB.get(`bg_${this.bg}_booksWalks`)
        .then(doc => {
          //console.log(navigator.onLine);
          if (navigator.onLine) {
            const currDate = new Date().getTime();
            const dbDate = new Date(doc.datetime).getTime();

            if (Math.abs(currDate - dbDate) / (1000 * 60 * 60) >= 10) {
              this.getBooksWalks();
              return;
            }
          }

          this.booksWalks = doc.booksWalks;
        })
        .catch(err => {
          this.booksWalks = [];

          if (navigator.onLine)
            this.getBooksWalks();
          //this.$alertMsg('No data found for offline mode');
        });
    },
    getBillingGroupName() {
      this.$store.state.readingsLocalDB.get(`billingGroups`)
        .then(doc => {
          this.bgName = doc.billingGroups.filter(a => a.id == this.bg)[0].name;
          this.key = this.key + 1;
        })
        .catch(err => {

        });
    },
  }
}
